module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-01-m-en.52e3f4682bd9db297aba9dcd06b2f8e6.png";